import { Link } from 'react-router-dom';

import { cn } from '@/lib/utils';
import type { ServerStatus } from '@/types/fleet';

const STATUS_DOT: Record<ServerStatus, string> = {
  active: 'bg-emerald-500',
  provisioning: 'bg-blue-500',
  quarantined: 'bg-amber-500',
  decommissioned: 'bg-slate-400',
};

export function ServerLink({
  name,
  status,
  className,
}: {
  name: string;
  status?: ServerStatus;
  className?: string;
}): JSX.Element {
  return (
    <Link
      to={`/fleet/${encodeURIComponent(name)}`}
      className={cn(
        'inline-flex items-center gap-1.5 font-medium text-primary hover:underline',
        className,
      )}
    >
      {status && (
        <span
          className={cn('h-2 w-2 shrink-0 rounded-full', STATUS_DOT[status])}
          aria-hidden
        />
      )}
      {name}
    </Link>
  );
}
